/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M16.44 9.815a6.625 6.625 0 1 0-3.123 5.625l4.926 4.931a1.5 1.5 0 1 0 2.123-2.12l-4.927-4.933a6.594 6.594 0 0 0 1-3.503Zm-11 0a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0Z"
})), "0 0 24 24", "Search");